/** @format */

import React, { useEffect, useRef, useState } from "react";

import { awsUrl, triggerGAEvent } from "../../helpers";
import { gsap } from "../../gsap";
import { SplitText } from "../../gsap/SplitText";
import { useGSAP } from "../../gsap/react";

gsap.registerPlugin(SplitText, useGSAP);

const AccordionSlide = ({ id, isActive, setActive, resetActive, initiated, onClick }) => {
  const accordionRef = useRef();
  const tl = useRef();
  const titleTag = useRef();
  const [videoPlaying, setVideoPlaying] = useState(false);

  let isMobile =
    window.matchMedia("(max-width: 992px)").matches ||
    window.matchMedia("(pointer: coarse)").matches;

  const { contextSafe } = useGSAP(
    () => {
      let mm = gsap.matchMedia();
      let splitHeadline = new SplitText(".title-tag", { type: "chars" });

      mm.add("(max-width: 992px)", () => {
        tl.current = gsap
          .timeline({
            paused: true
            // reversed: true
          })
          .to(accordionRef.current, {
            width: "80%"
          })
          .to(
            titleTag.current,
            {
              opacity: 0,
              duration: 0
            },
            "0"
          )
          .to(titleTag.current, {
            opacity: 0.75
          })
          .to(
            splitHeadline.chars,
            {
              duration: 0.75,
              x: 50,
              stagger: 0.05
            },
            "<"
          );
      });

      mm.add("(min-width: 992px)", () => {
        tl.current = gsap
          .timeline({
            paused: true
            // reversed: true
          })
          .to(accordionRef.current, {
            width: "80%"
          })
          .to(
            titleTag.current,
            {
              opacity: 0,
              duration: 0
            },
            "0"
          )
          .to(titleTag.current, { rotate: 270, x: "120%", y: "20%" }, "<")
          .to(
            titleTag.current,
            {
              opacity: 0.75
            },
            "<"
          )
          .to(
            splitHeadline.chars,
            {
              duration: 0.75,
              x: 50,
              stagger: 0.05
            },
            "<"
          );
      });
    },
    { scope: accordionRef }
  );

  const playVideo = contextSafe((event) => {
    if (!videoPlaying) {
      setVideoPlaying(true);
    }

    triggerGAEvent("accordion_" + event);
    tl.current.restart();
    tl.current.play();
  });

  const pauseVideo = contextSafe((event) => {
    let videoRef = document.querySelector(`#video-` + event);

    if (videoPlaying) {
      videoRef.pause();
      setVideoPlaying(false);
    }

    tl.current.revert();
  });

  const Video = ({ id }) => {
    return (
      <div className="h-full">
        {" "}
        {!videoPlaying && (
          <div
            className="h-full"
            dangerouslySetInnerHTML={{
              __html: `
              <video
                id=${"video-" + id}
                className="accordion-video"
                muted
                loop
                playsinline
                poster=${awsUrl}/media/accordion-${id}.jpg?v=1
              >
                <source src=${awsUrl}/media/accordion-${id}.mp4?v=1 type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            `
            }}
          ></div>
        )}
        {videoPlaying && (
          <div
            className="h-full"
            dangerouslySetInnerHTML={{
              __html: `
                <video
                  id=${"video-" + id}
                  className="accordion-video"
                  muted
                  loop
                  autoplay
                  playsinline
                  poster=${awsUrl}/media/accordion-${id}.jpg?v=1
                >
                  <source src=${awsUrl}/media/accordion-${id}.mp4?v=1 type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              `
            }}
          ></div>
        )}
      </div>
    );
  };

  const inactiveActive = isActive ? "active" : !initiated ? "initial" : "inactive";
  const hoverNoHover = isActive ? "active-m" : !initiated ? "initial" : "inactive";
  const styled = isMobile ? hoverNoHover : inactiveActive;

  useEffect(() => {
    isActive && initiated ? playVideo(id) : pauseVideo(id);
  }, [isActive, initiated, id, playVideo, pauseVideo]);

  return (
    <li
      ref={accordionRef}
      className={`bg-dark-blue box box--` + id + ` initial ` + styled}
      id={id}
      data-key={id}
      onMouseEnter={setActive}
      onClick={onClick}
      onMouseLeave={resetActive}
      aria-label={id}
      aria-hidden="true"
    >
      <div
        ref={titleTag}
        aria-hidden="true"
        className="title-tag text-tempo z-[100] opacity-50 tracking-widest pointer-events-none"
      >
        {id}
      </div>

      <div className="image w-full h-full relative overflow-hidden ">
        <Video id={id}></Video>
      </div>
    </li>
  );
};

export default AccordionSlide;
